import { shortTitle } from "@utils/product/productFormatters";

const getShortTitle = (item: any, productType: string) => {
  if (item) {
    if (productType === "gemstone") {
      return item.short_title;
    } else if (productType === "jewelry") {
      return item.short_title;
    } else {
      return item.short_title ?? shortTitle(item);
    }
  }
};

export enum ProductAttributeObject {
  sub_title = "sub_title",
  stock_no = "stock_no",
  cut = "cut",
  polish = "polish",
  symmetry = "symmetry",
  fluor_intensity = "fluor_intensity",
}

export { getShortTitle };
